var app;

app = window.App || (window.App = {});

app.Notes = {
  addNote: function(note) {
    $('#notes-list').prepend(note);
    $('#notes-list .pagination-info').text('');
    new app.ElementSwapper().swap.call($('#notes-form'));
    app.Notes.resetForm();
    return app.Notes.hideError();
  },
  resetForm: function() {
    return $('#notes-form').find('form')[0].reset();
  },
  focus: function() {
    return setTimeout(function() {
      return $('#note_text').focus();
    });
  },
  showError: function(error) {
    return $('#notes-error').text(error).show();
  },
  hideError: function() {
    return $('#notes-error').text('').hide();
  }
};

$(document).on('turbo:load', function() {
  $('#notes-new-button').on('click', app.Notes.focus);
  $('#notes-form .cancel').on('click', new app.ElementSwapper().swap);
  return $('#notes-form .cancel').on('click', function() {
    app.Notes.resetForm();
    return app.Notes.hideError();
  });
});
